import { DeviceAlert, RawDeviceV2 } from "@/entities";

export class DeviceV2 {
   id: string;
   code: string;
   name: string;
   type: string;
   manufacturer: string;
   model: string;
   active: boolean;
   currencies: string[];
   manufacturerNoteCapacity: number;
   realNoteCapacity: number;
   prosegurNoteCapacity: number;
   manufacturerCoinCapacity: number;
   realCoinCapacity: number;
   prosegurCoinCapacity: number;
   clientMode: string;
   countryCode: string;
   deviceAlerts: DeviceAlert[];

  constructor(data: RawDeviceV2) {
    this.id = data.id || "";
    this.code = data.code || "";
    this.name = data.name || "";
    this.type = data.type || "";
    this.manufacturer = data.manufacturer || "";
    this.model = data.model || "";
    this.active = data.active || true;
    this.currencies = data.currencies || "";
    this.manufacturerNoteCapacity = data.manufacturerNoteCapacity || 0;
    this.realNoteCapacity = data.realNoteCapacity || 0;
    this.prosegurNoteCapacity = data.prosegurNoteCapacity || 0;
    this.manufacturerCoinCapacity = data.manufacturerCoinCapacity || 0;
    this.realCoinCapacity = data.realCoinCapacity || 0;
    this.prosegurCoinCapacity = data.prosegurCoinCapacity || 0;
    this.deviceAlerts = data.deviceAlerts || [];
    this.clientMode = data.clientMode || "";
    this.countryCode = "";
  }
}
